import { render, staticRenderFns } from "./AIContent1.vue?vue&type=template&id=0d6cf645"
import script from "./AIContent1.vue?vue&type=script&lang=js"
export * from "./AIContent1.vue?vue&type=script&lang=js"
import style0 from "./AIContent1.vue?vue&type=style&index=0&id=0d6cf645&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports